/*
 *
 * Accessible
 * 
 * This module will handle adding and removing classes on elements 
 * when focus or blur events occur, typically used for keyboard 
 * navigation and accessibly rich internet applications.
 * 
 *  Usage:
 *  Access = require('./modules/Accessible.js');
 *  Accessible.init(element);
 *  
 *  Note: This should be used on the parent element as it allow bubbling,
 *  not the anchor.
 * 
 *  e.g. <li class="menu-item"> ... </li>
 *
 * Additional resources:
 * https://developer.mozilla.org/en-US/docs/Learn/Tools_and_testing/Cross_browser_testing/Accessibility
 * 
 * ! Firefox for the Mac doesn't do tabbing by default. To turn it on, you have to go to 
 *    Preferences > Advanced > General, then uncheck "Always use the cursor keys to navigate within pages". 
 *    Next, you have to open your Mac's System Preferences app, then go to Keyboard > Shortcuts, 
 *    then select the All Controls radio button.
 * 
 * ! Safari doesn't allow you to tab through links by default; to enable this, you need to open 
 *    Safari's Preferences, go to Advanced, and check the Press Tab to highlight each item on a webpage checkbox.
 */

const Accessible = {
	init(className) {

		if (typeof NodeList.prototype.forEach !== 'function')  {
			NodeList.prototype.forEach = Array.prototype.forEach;
		}

		const els = document.querySelectorAll(className);

		els.forEach((el) => {
			el.addEventListener("focusin", () => el.classList.add('focused'));
			el.addEventListener("focusout", () => el.classList.remove('focused'));
		});
	}
};

export default Accessible;
